import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { cn } from '@/lib/utils'
import { UNASSIGNED, type Group, type TreeProps } from './api'
import NewGroupRow from './NewGroupRow'

interface Props {
  groups: Group[]
  unassignedCount: number
  selectedId: string
  adding: { parentId: string | null } | null
  onSelect: (id: string) => void
  onAdd: (parentId: string | null) => void
  onCancelAdd: () => void
  onCreated: (tree: TreeProps) => void
}

function Row({ label, count, depth, selected, onClick }: {
  label: string; count: number; depth: number; selected: boolean; onClick: () => void
}) {
  return (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn('h-8 w-full justify-between rounded-none px-3 font-normal', selected && 'bg-accent text-primary')}
      style={{ paddingLeft: 12 + depth * 16 }}
    >
      <span className="truncate">{label}</span>
      <span className="ml-2 tabular-nums">{count.toLocaleString()}</span>
    </Button>
  )
}

export default function GroupTree({ groups, unassignedCount, selectedId, adding, onSelect, onAdd, onCancelAdd, onCreated }: Props) {
  return (
    <div>
      <div className="flex items-center justify-between border-b border-border px-3 py-2">
        <span className="text-sm font-medium text-foreground">Groups</span>
        <Button size="sm" variant="outline" className="h-8" onClick={() => onAdd(null)}>
          <Plus size={14} className="mr-1" /> Add group
        </Button>
      </div>
      <div className="divide-y divide-border">
        <Row label="Unassigned" count={unassignedCount} depth={0} selected={selectedId === UNASSIGNED} onClick={() => onSelect(UNASSIGNED)} />
        {adding && adding.parentId === null && (
          <NewGroupRow parentId={null} depth={0} onCreated={onCreated} onCancel={() => onCancelAdd()} />
        )}
        {groups.map((g) => (
          <div key={g.id}>
            <Row label={g.name} count={g.product_count} depth={g.depth} selected={selectedId === g.id} onClick={() => onSelect(g.id)} />
            {adding && adding.parentId === g.id && (
              <NewGroupRow parentId={g.id} depth={g.depth + 1} onCreated={onCreated} onCancel={() => onCancelAdd()} />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
